'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import LinkedInTag from 'react-linkedin-insight'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactFacebookPixelIyv = require('../../helpers/react-facebook-pixel-iyv');

var _reactFacebookPixelIyv2 = _interopRequireDefault(_reactFacebookPixelIyv);

var _components = require('../../components');

var _PetitionForm = require('./PetitionForm.css');

var _PetitionForm2 = _interopRequireDefault(_PetitionForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PetitionForm = (_dec = (0, _reactCssModules2.default)(_PetitionForm2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PetitionForm, _Component);

  function PetitionForm(props) {
    (0, _classCallCheck3.default)(this, PetitionForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PetitionForm.__proto__ || (0, _getPrototypeOf2.default)(PetitionForm)).call(this, props));

    _this.log = function () {
      var _this$state = _this.state,
          companyName = _this$state.companyName,
          petitionName = _this$state.petitionName;


      if (companyName && petitionName) {
        _analytics2.default.event(_analytics2.default.eventStaffSupport(companyName, petitionName));
      }

      // if (config.linkedinPid && linkedinTrackingId) {
      //   LinkedInTag.track(linkedinTrackingId)
      // }

      if (_config2.default.fbPixelId && companyName && petitionName) {
        _reactFacebookPixelIyv2.default.track('Lead', {
          content_name: companyName + ' ' + petitionName
        });
      }
    };

    var petitionConfig = props.petitionConfig || {};
    _this.state = {
      companyName: petitionConfig.companyName || null,
      petitionName: petitionConfig.petitionName || null,
      // linkedinTrackingId: petitionConfig.linkedinTrackingId || null,
      pardotFormUrl: petitionConfig.pardotFormUrl || null,
      pardotFirstNameId: petitionConfig.pardotFirstNameId || null,
      pardotLastNameId: petitionConfig.pardotLastNameId || null,
      pardotEmailId: petitionConfig.pardotEmailId || null
    };
    return _this;
  }

  (0, _createClass3.default)(PetitionForm, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.myFormRef.reset();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          pardotFormUrl = _state.pardotFormUrl,
          pardotFirstNameId = _state.pardotFirstNameId,
          pardotLastNameId = _state.pardotLastNameId,
          pardotEmailId = _state.pardotEmailId;


      if (!pardotFormUrl || !pardotFirstNameId || !pardotLastNameId || !pardotEmailId) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'form-wrap' },
        _react2.default.createElement(
          'form',
          {
            styleName: 'form',
            acceptCharset: 'UTF-8',
            method: 'post',
            action: pardotFormUrl,
            target: 'signup_confirmation',
            ref: function ref(el) {
              return _this2.myFormRef = el;
            }
          },
          _react2.default.createElement(
            'label',
            { htmlFor: pardotFirstNameId },
            'First Name'
          ),
          _react2.default.createElement('input', { styleName: 'input',
            name: pardotFirstNameId,
            type: 'text',
            placeholder: ''
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: pardotLastNameId },
            'Last Name'
          ),
          _react2.default.createElement('input', { styleName: 'input',
            name: pardotLastNameId,
            type: 'text',
            placeholder: ''
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: pardotEmailId },
            'Email*',
            _react2.default.createElement(
              'sup',
              null,
              ' (Required)'
            )
          ),
          _react2.default.createElement('input', { styleName: 'input',
            name: pardotEmailId,
            type: 'email',
            placeholder: '',
            required: true
          }),
          _react2.default.createElement(
            'div',
            {
              style: {
                position: 'absolute',
                left: '-9999px',
                top: '-9999px'
              }
            },
            _react2.default.createElement(
              'label',
              { htmlFor: 'pardot_extra_field' },
              'Comments'
            ),
            _react2.default.createElement('input', {
              type: 'text',
              id: 'pardot_extra_field',
              name: 'pardot_extra_field',
              tabIndex: '-1'
            })
          ),
          _react2.default.createElement(
            'button',
            {
              styleName: 'submit',
              type: 'submit',
              value: '',
              onClick: this.log
            },
            'Sign the petition'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'We\'ll send you email updates on this campaign. ',
          _react2.default.createElement(
            _components.Link,
            {
              to: _config2.default.routes.legal,
              title: 'Privacy policy',
              xstrong: true
            },
            'Read our privacy policy'
          )
        )
      );
    }
  }]);
  return PetitionForm;
}(_react.Component), _class2.propTypes = {
  petitionConfig: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PetitionForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PetitionForm/PetitionForm.js
// module id = 1391
// module chunks = 0